export default __webpack_public_path__ + "static/media/02.eefa0ba9.jpg";